import { render, staticRenderFns } from "./InsuranceCompanyCard.vue?vue&type=template&id=ae6cfbea"
import script from "./InsuranceCompanyCard.vue?vue&type=script&lang=js"
export * from "./InsuranceCompanyCard.vue?vue&type=script&lang=js"
import style0 from "./InsuranceCompanyCard.vue?vue&type=style&index=0&id=ae6cfbea&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports